import React, { Component } from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import { Link } from "react-router-dom";

import logo from './logo.svg';

const items = [
    ["/dns", "DNS"],
    ["/spf", "SPF"],
    ["/rbl", "RBL"],
    ["/network", "Network"],
];

const navbar = (
  <Nav>
    {items.map((item) => 
      <NavItem key={item[0]} componentClass={Link} eventKey={1} href={item[0]} to={item[0]}>
        {item[1]}
      </NavItem>
    )}
  </Nav>
);

class Navigation extends Component {
  render() {
    return (
      <Navbar>
        <Navbar.Header>
          <Navbar.Brand>
          <Link to="/">
            <img src={logo} className="App-logo" alt="logo" />
            E-mail tools
          </Link>
          </Navbar.Brand>
        </Navbar.Header>
        {navbar}
      </Navbar>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Navigation.js